import React from 'react';
import AuthorizedAction from '../AuthorizedAction.js';
import {
  ChangeInsightsAnalysisLink,
  ChangeInsightsStudioLink,
  InitiativeFilesLink,
  InitiativeLink,
} from '../links/index.jsx';
import Tabs from '../Tabs.jsx';

const InitiativeTabs = ({ initiative }) => (
  <Tabs>
    <Tabs.Tab label="Overview">
      <InitiativeLink initiative={initiative} />
    </Tabs.Tab>
    <Tabs.Tab label="ChangeInsights Studio">
      <ChangeInsightsStudioLink initiative={initiative} />
    </Tabs.Tab>
    <AuthorizedAction action="aiAnalysis" subject="survey">
      <Tabs.Tab label="ChangeInsights Analysis">
        <ChangeInsightsAnalysisLink initiative={initiative} />
      </Tabs.Tab>
    </AuthorizedAction>
    <Tabs.Tab label="Linked Files">
      <InitiativeFilesLink initiative={initiative} />
    </Tabs.Tab>
  </Tabs>
);

export default InitiativeTabs;
